import { useTranslation } from "react-i18next";
import BorderRow from "../../../components/common/table/BorderRow";
import { TableHeaderWrapper } from "../../../components/common/Common.styles";
import ServerSideTableColumnHeader from "../../../components/common/table/ServerSideTableColumnHeader";
import { PaginatedData } from "../../../hooks/PaginationHooks";

interface EmployeesTableHeaderProps {
  paginatedData: PaginatedData<any>
}

const EmployeesTableHeader = ({
  paginatedData,
}: EmployeesTableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <TableHeaderWrapper>
      <ServerSideTableColumnHeader
        fieldName="firstName"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.firstName")}
        firstCol
        stickyFirstCol
      />
      <ServerSideTableColumnHeader
        fieldName="lastName"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.lastName")}
      />
      <ServerSideTableColumnHeader
        fieldName="birthDate"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.birthDate")}
      />
      <ServerSideTableColumnHeader
        fieldName="employmentDate"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.employmentDate")}
      />
      <ServerSideTableColumnHeader
        fieldName="position"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.position")}
      />
      <ServerSideTableColumnHeader
        fieldName="employeeNumber"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.employeeNo")}
      />
      <ServerSideTableColumnHeader
        fieldName="status"
        isSorted
        label={t("tableColumnHeaders.status")}
        paginatedData={paginatedData}
      />
      <ServerSideTableColumnHeader
        fieldName="group"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.groups")}
      />
      <ServerSideTableColumnHeader
        fieldName="subCompany"
        isSorted
        paginatedData={paginatedData}
        label={t("tableColumnHeaders.subCompany")}
      />
      <ServerSideTableColumnHeader
        fieldName="modules"
        isSorted={false}
        label={t("tableColumnHeaders.modules")}
        paginatedData={paginatedData}
      />
      <ServerSideTableColumnHeader
        fieldName="registrationCode"
        isSorted
        lastCol
        label={t("tableColumnHeaders.invitationCode")}
        paginatedData={paginatedData}
      />
      <BorderRow />
    </TableHeaderWrapper>
  );
};

export default EmployeesTableHeader;
